export const BILL_TYPE_DEPOSIT = "定金单";
export const BILL_TYPE_DELIVERY = "发货单";
export const BILL_TYPE = {
    0: BILL_TYPE_DEPOSIT,
    1: BILL_TYPE_DELIVERY
};
export const BILL_AUDIT_SAVE = "保存";
export const BILL_AUDIT_SUBMIT= "提交";
export const BILL_AUDIT_PASS = "通过";
export const BILL_AUDIT_REJECT = "驳回";

export const BILL_AUDIT = {
    0: BILL_AUDIT_SAVE,
    1: BILL_AUDIT_SUBMIT,
    2: BILL_AUDIT_PASS,
    3: BILL_AUDIT_REJECT
};

export const CUSTOMER = "客户";
export const SEEDFARM = "苗场";
export const BREACHING_PARTY = {
    0: CUSTOMER,
    1: SEEDFARM
};
export const BREACHING_PARTY_NAME = {
    "客户": 0,
    "苗场": 1
};
export const ALL = "全部";
export const PART = "部分";
export const TYPE_NAME= {
    "全部": 0,
    "部分": 1
};
export const BREACHING_PARTY_NAME_OPTION = [
    { key: CUSTOMER, value: 0 },
    { key: SEEDFARM, value: 1 }
];

export const TYPE_OPTION= [
    { key: ALL, value: 0 },
    { key: PART, value: 1 }
];
